import React from 'react';
import { X } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

const PremiumModal = ({ isOpen, onClose, title, description, featureName }) => {
    const navigate = useNavigate();

    if (!isOpen) return null;

    return (
        <div className="fixed inset-0 z-[100] flex items-center justify-center px-4">
            {/* Backdrop */}
            <div
                className="absolute inset-0 bg-slate-900/60 backdrop-blur-sm transition-opacity"
                onClick={onClose}
            />

            {/* Modal Content */}
            <div className="relative bg-white rounded-[32px] w-full max-w-md p-8 shadow-2xl transform transition-all scale-100 animate-in fade-in zoom-in-95 duration-200">

                {/* Close Button */}
                <button
                    onClick={onClose}
                    className="absolute top-4 right-4 p-2 text-slate-400 hover:text-slate-600 hover:bg-slate-50 rounded-full transition-colors"
                >
                    <X size={24} />
                </button>

                {/* Icon/Image */}
                <div className="flex justify-center mb-6">
                    <div className="w-20 h-20 bg-violet-50 rounded-3xl flex items-center justify-center transform rotate-3 shadow-sm border border-violet-100">
                        <img
                            src="/assets/Trouve_plus.png"
                            alt="Trouve+"
                            className="w-12 h-12 object-contain"
                        />
                    </div>
                </div>

                {/* Text Content */}
                <div className="text-center mb-8">
                    <h3 className="text-2xl font-black text-slate-900 mb-3 tracking-tight">
                        {title}
                    </h3>
                    <p className="text-slate-500 font-medium leading-relaxed mb-6">
                        {description}
                    </p>
                    {featureName && (
                        <div className="inline-flex items-center gap-2 px-4 py-2 bg-violet-50/50 rounded-full border border-violet-100">
                            <div className="w-2 h-2 rounded-full bg-violet-500 animate-pulse" />
                            <span className="text-sm font-black tracking-wider uppercase text-transparent bg-clip-text bg-gradient-to-r from-blue-600 to-violet-600">
                                PREMIUM
                            </span>
                        </div>
                    )}
                </div>

                {/* Action Button */}
                <button
                    onClick={() => navigate('/trouve-plus')}
                    className="w-full py-4 rounded-xl bg-slate-900 group hover:bg-slate-800 transition-all transform active:scale-[0.98] shadow-xl shadow-slate-900/20 relative overflow-hidden"
                >
                    <div className="absolute inset-0 bg-gradient-to-r from-blue-600/20 to-purple-600/20 opacity-0 group-hover:opacity-100 transition-opacity" />
                    <div className="flex items-center justify-center gap-2 relative z-10">
                        <span className="text-white font-bold text-lg">Découvrir</span>
                        <span className="px-2 py-0.5 rounded bg-white/10 text-white font-black text-sm border border-white/20">
                            Trouve<span className="text-transparent bg-clip-text bg-gradient-to-r from-blue-400 to-purple-400">+</span>
                        </span>
                    </div>
                </button>
            </div>
        </div>
    );
};

export default PremiumModal;
